import { Component, OnInit } from '@angular/core';

import { MatSnackBar } from "@angular/material/snack-bar";
import { Subscription, Subject } from 'rxjs';

///IDIOMAS
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

//SERVICE
import { NpsService } from "app/main/pagina/productos/certificar/tipo_1/services/nps.service";
import {TranslateService} from '@ngx-translate/core';
import { BroadcastTranslate } from '../broadcasttranslate.service';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';

@Component({
  selector: 'app-traducciones',
  templateUrl: './traducciones.component.html',
  styleUrls: ['./traducciones.component.scss']
})
export class TraduccionesComponent implements OnInit {
 
  nps: any;
  subscription: Subscription;
  private _unsubscribeAll: Subject<any>;
  traducciones: any = [];

  constructor(
                private npsService: NpsService,
                private wizardService: WizardService,
                public snackBar: MatSnackBar,
                private _fuseTranslationLoaderService: FuseTranslationLoaderService,
                private serviceTranslate: TranslateService,
                private broadcast: BroadcastTranslate

  ) {
    this._unsubscribeAll = new Subject();

    lang_certificar.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    this.subscription = this.broadcast.getEvent().subscribe(product => {
       console.log('traducciones');
       this.getTraducciones();
     });
   }
   instituto:any;
  ngOnInit() {
    this.obtieneInstituto();
  }

  obtieneInstituto(){
    let institutoAct = this.wizardService.getInstituto();
    // console.log(institutoAct);
    switch(institutoAct){
      case '1': case 'MX': this.instituto = 'MX'; break;
case '2': case 'CAyC': this.instituto = 'CAyC'; break;
case '3': case 'HK': this.instituto = 'HK'; break;
case '4': case 'SGP': this.instituto = 'SGP'; break;
case '5': case 'TK': this.instituto = 'TK'; break;
case '6': case 'FL': this.instituto = 'FL'; break;
case '11': case 'BR': this.instituto = 'BR'; break;
    }
    console.log("Instituo "+this.instituto);
  }

  public getTraducciones(){
    let data = {
      productoId: localStorage.getItem('productoID')
    }

    this.npsService.getTraducciones(data)
    .subscribe(response => {
      console.log(response);

      if(response['message'] == 'Success'){
        this.traducciones = response['arrayMostrar'];
      }

    }, error => {
      console.log("error", error);
    });
  }

  saveQuestionTranslate(event,idNps,idiomaID){
    if(event.target.value.length > 0){
        let data = {
          productoId: localStorage.getItem('productoID'),
          idNps: idNps,
          pregunta: event.target.value,
          idiomaId: idiomaID
        }

        this.npsService.updateTraducciones(data)
        .subscribe(response => {
            if(response['message'] == 'Success'){
               this.openSuccessSnackBar(this.serviceTranslate.instant('CERTIFICAR.FORALL.QUESTIONUPDATEDOK'),this.serviceTranslate.instant('ALERTS.OK'));
            }


        }, error => {
          console.log("error", error);
        });
    }else{
      this.openErrorSnackBar('Please, insert the translate','OK');
    }
  }


  openErrorSnackBar(message: string, action: string) {
      this.snackBar.open(message, action, {
         duration: 15000,
         verticalPosition: 'top',
         panelClass: ['background-red']
      });
   }


   openSuccessSnackBar(message: string, action: string) {
      this.snackBar.open(message, action, {
         duration: 15000,
         verticalPosition: 'top',
         panelClass: ['background-success']
      });
   }

}
